export const SORT_TYPES = {
  text: { asc: 'A → Z', desc: 'Z → A' },
  date: { asc: 'Earliest → Latest', desc: 'Latest → Earliest' },
  number: { asc: '1 → 9', desc: '9 → 1' },
  currency: { asc: 'Lowest → Highest', desc: 'Highest → Lowest' },
  quantity: { asc: 'Lowest → Highest', desc: 'Highest → Lowest' },
};

export const ADDON_COLUMNS = [
  { id: 'add_on_name', label: 'Add-On', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'event_name', label: 'Event', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'text' },
  { id: 'venue_name', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'qty', label: 'Qty', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'quantity' },
  { id: 'amount', label: 'Amount', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'currency' },
  { id: 'order_date', label: 'Order Date', alwaysVisible: false, defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'customer_name', label: 'Customer Name', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'customer_email', label: 'Customer Email', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'sold_by', label: 'Sold By', alwaysVisible: false, defaultVisible: false, sortable: true, sortType: 'text' },
  { id: 'device_name', label: 'Device', alwaysVisible: false, defaultVisible: false, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  ADDON_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  ADDON_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
